export interface ApiErrorPayload {
  message?: string;
  code?: string;
  feature?: string;
  plan?: string;
  limit?: number | null;
  usage?: number;
  upgrade_required?: boolean;
}

export const getApiErrorPayload = (error: any): ApiErrorPayload => {
  return (
    error?.response?.data || {
      message: "Something went wrong.",
    }
  );
};

export const isSubscriptionLimitPayload = (payload: unknown): boolean => {
  return (
    !!payload &&
    typeof payload === "object" &&
    "code" in payload &&
    payload.code === "subscription_limit_reached"
  );
};

export const getApiErrorMessage = (
  payload: unknown,
  fallbackMessage: string,
): string => {
  if (typeof payload === "string") {
    return payload;
  }

  if (
    payload &&
    typeof payload === "object" &&
    "message" in payload &&
    typeof payload.message === "string"
  ) {
    return payload.message;
  }

  return fallbackMessage;
};
